
export function requestAnimationDebounce<T extends Function>(fn: T) {
  let timer: number = -1
  return function (this: any, ...args: any) {
    cancelAnimationFrame(timer)
    timer = requestAnimationFrame(() => {
      fn.apply(this, args)
    })
  }
}

export const isEllipsisHeight = (dom: any, maxWidth: any, parentNode: any) => {
  const checkDom = dom.cloneNode();
  const computedStyle = window.getComputedStyle(dom);
  let parent, flag;
  checkDom.style.cssText = `
  diaplay: block;
  max-width: initial;
  width: ${dom.offsetWidth}px;
  height: auto;
  overflow: unset;
  position: absolute;
  top: 0;
  zIndex: -99;
  opacity: 0;
  whiteSpace: nowrap;
  font-family: ${computedStyle.fontFamily};
  font-size: ${computedStyle.fontSize};
  display: block;
  `;

  checkDom.innerHTML = dom.innerHTML;

  parent = document.body;

  parent.appendChild(checkDom);
  const autoHeight = checkDom.getBoundingClientRect().height;
  const realHeight = maxWidth || dom.getBoundingClientRect().height;
  flag = autoHeight > realHeight;
  parent.removeChild(checkDom);
  return flag;
};
/**
 * 内容判断是否超出容器
 */
export function isEllipsis(dom: HTMLElement, maxWidth?: number) {
  const checkDom = dom.cloneNode() as HTMLElement
  const computedStyle = window.getComputedStyle(dom)
  let parent, flag
  checkDom.style.cssText = `
    display: block;
    max-width: initial;
    width: auto;
    height: ${dom.offsetHeight}px;
    overflow: unset;
    position: absolute;
    zIndex: -1;
    opacity: 0;
    whiteSpace: nowrap;
    font-family: ${computedStyle.fontFamily};
    font-size: ${computedStyle.fontSize}
    `

  checkDom.innerHTML = dom.innerHTML

  parent = document.body

  parent.appendChild(checkDom)
  const autoWidth = checkDom.getBoundingClientRect().width
  const realWidth = maxWidth || dom.getBoundingClientRect().width
  flag = autoWidth > realWidth
  parent.removeChild(checkDom)
  return flag
}

export type DebounceHandler<T> = {
  (...h: any): T
  clear: () => void
}
export function debounce<T>(wait: number, fn: (...h: any) => T) {
  let timer: any

  const handleFn = function (this: any, ...args: any) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, wait);
  }
  handleFn.clear = () => {
    clearTimeout(timer)
    return handleFn
  }
  return handleFn
}

export function throttle(time: number, handleFn: (...h: any) => any) {
  let starTime = -Infinity
  const dd = debounce(time, handleFn)
  return function tt(this: any, ...arg: any) {
    const nowTime = performance.now()
    if (nowTime - starTime >= time) {
      handleFn.call(this, ...arg)
      starTime = nowTime
    } else {
      dd.call(this, ...arg)
    }
  }
}
export function isPromise<T>(val: unknown): val is Promise<T> {
  return Object.prototype.toString.call(val) === '[object Promise]'
}
export type RafInterval = {
  (): void
  clear: () => void
  start: (h?: any) => void
}
export function getRaf(cb: (h?: any) => any, time = 0): RafInterval {
  let rafId: number | null = null
  let keep = true
  let startTime = -Infinity
  const thresholdTime = time
  async function rafFn(this: any, ...arg: any) {
    let currentTime = performance.now()
    if (currentTime - startTime < thresholdTime) {
      cancelAnimationFrame(rafId as number)
      rafId = requestAnimationFrame(rafFn.bind(this, ...arg))
      return
    }
    startTime = performance.now()
    try {
      const cbRes = cb.apply(this, arg)
      if (isPromise(cbRes)) {
        await cbRes
      }
    } catch (err) {
      console.error(err)
    }
    if (!keep) return
    rafId = requestAnimationFrame(rafFn.bind(this, ...arg))
  }
  rafFn.clear = () => {
    keep = false
    if (rafId) cancelAnimationFrame(rafId)
  }
  rafFn.start = (h?: any) => {
    rafFn.clear()
    keep = true
    rafFn(h)
  }
  return rafFn
}

/**
 * @description: 处理跟随tip或者弹窗，滚动时抖动问题
 * @return {*}
 */
export function addScrollRefresh(fn: (e: Event) => void): () => void {
  const raf = getRaf(fn)
  let isStart = false
  const scrollStart = (e: Event) => {
    if (!isStart) {
      isStart = true
      raf.start(e)
    }
  }
  const scrollStop = debounce(320, () => {
    raf.clear()
    isStart = false
  })
  const scrollCb = (e: Event) => {
    scrollStart(e)
    scrollStop(e)
  }
  window.addEventListener('resize', scrollCb)
  window.addEventListener('scroll', scrollCb, { capture: true })
  return () => {
    window.removeEventListener('scroll', scrollCb, { capture: true })
    window.removeEventListener('resize', scrollCb)
    raf.clear()
  }
}
